import dashboard from "./dashboardReducer";
import campaign from "./campaignReducer";
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    dashboard,
    campaign,
});

export default rootReducer;